import { RootStore } from './rootStore';
import { observable, action, computed, runInAction } from 'mobx';
import agent from '../api/agent';
import { history } from '../..';
import { toast } from 'react-toastify';
import { IHelp } from '../models/help';

export default class HelpStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    @observable loadingInitial = true;
    @observable submitting = false;
    @observable errorMessage: string = '';

    @observable help: IHelp | null = null;
    @observable helpRegistry = new Map();
    @observable deleteErrorMessage: string ='';

    // list
    @observable helpCount = 0;
    @observable currentPage = 1;
    @observable totalPage = 1;
    @observable pageSize: number = 7;

    @computed get getHelps() {
        if (this.helpRegistry.size >= 1) {
            return Array.from(this.helpRegistry.values());
        }
        return [];
    }

    @action setPageSize = (pageSize: number) => {
        this.pageSize = pageSize;
    }

    @action setCurrentPage = (page: number) => {
        this.currentPage = page;
    }

    @action createHelp = async (formData: FormData) => {
        try {
            var help = await agent.Helps.create(formData);

            runInAction('creating help', () => {
                this.submitting = true;
                this.helpRegistry.set(help.id, help);
                this.submitting = false;
                toast.info(help.title + 'is created.');
                history.push(`/helps`);
            });
        } catch (error) {
            runInAction('Problem submitting data', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    @action editHelp = async (formData: FormData, id: string) => {
        this.submitting = true;
        try {
            var help = await agent.Helps.update(formData, id);

            runInAction('editing bulletin', () => {
                this.helpRegistry.set(help.id, help);
                this.submitting = false;
            });
            history.push(`/helps`);
        } catch (error) {
            runInAction('Problem submitting data ', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    @action loadHelps = async () => {
        try {
            const params = new URLSearchParams();
            params.append('currentPage', `${this.currentPage}`);
            params.append('pageSize', `${this.pageSize}`);
            let helpsResourceModel = await agent.Helps.list(params);

            runInAction('loading helps', () => {
                if (helpsResourceModel) {
                    this.helpRegistry.clear();
                    const { currentPage, count, totalPage, data } = helpsResourceModel;
                    data.forEach((help: any) => {
                        this.helpRegistry.set(help.id, help);
                    });
                    this.currentPage = currentPage;
                    this.totalPage = totalPage;
                    this.helpCount = count;
                    this.loadingInitial = false;
                }
            });
        } catch (error) {
            runInAction('load helps error', () => {
                this.loadingInitial = false;
            });
            throw error;
        }
    };

    @action loadHelp = async (id: string) => {
        try {
            let help = await agent.Helps.details(id);

            runInAction('loading help', () => {
                this.loadingInitial = false;
                this.errorMessage ='';
                this.deleteErrorMessage='';    
                this.help = help;
            });
            return help;

        } catch (error) {
            runInAction('load help error', () => {
                this.loadingInitial = false;
            });
            throw error;
        }
    };

    @action deleteById = async (id: string) => {
        try {
            await agent.Helps.delete(id);
            runInAction('deleting help', () => {
                this.helpRegistry.delete(id);
            });
        } catch (error) {
            runInAction('delete help error', () => {
            });
            console.log(error);
        }
    };
}